import {
  API_ERROR,
  DASHBOARD_FILTERS, DASHBOARD_REPORT_LOGIN_TOKEN, DASHBOARD_SYNC, DASHBOARD_SYNC_RESULT,
  LOGIN_SUCCESS,
  LOGIN_USER,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS, NOTES_REPORT_LOGIN_TOKEN,
  SOCIAL_LOGIN, SOCIAL_LOGIN_TOKEN, SOCIAL_LOGIN_TOKEN_RESULT
} from "./actionTypes"
import { getOneSignalHelper } from "../../../helpers/onesignal_helper"

export const loginUser = (user, history) => {
  return {
    type: LOGIN_USER,
    payload: { user, history }
  }
}

export const loginSuccess = data => {
  getOneSignalHelper().setUserData(data.user).then()

  return {
    type: LOGIN_SUCCESS,
    payload: { data }
  }
}

export const logoutUser = history => {
  return {
    type: LOGOUT_USER,
    payload: { history }
  }
}

export const logoutUserSuccess = () => {
  getOneSignalHelper().removerUserData().then()

  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {}
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error
  }
}

export const socialLogin = (data, history, type) => {
  return {
    type: SOCIAL_LOGIN,
    payload: { data, history, type }
  }
}

export const setDashboardFilters = filters => {
  return {
    type: DASHBOARD_FILTERS,
    payload: { filters }
  }
}

export const dashboardSync = (data, type) => {
  return {
    type: DASHBOARD_SYNC,
    payload: {data, type}
  }
}

export const dashboardSyncResult = (data, type) => {
  return {
    type: DASHBOARD_SYNC_RESULT,
    payload: {data, type}
  }
}


export const socialLoginToken = (data) => {
  return {
    type: SOCIAL_LOGIN_TOKEN,
    payload: { data }
  }
}

export const socialLoginTokenResult = (data) => {
  return {
    type: SOCIAL_LOGIN_TOKEN_RESULT,
    payload: { data }
  }
}

export const dashboardReportLoginToken = (data) => {
  return {
    type: DASHBOARD_REPORT_LOGIN_TOKEN,
    payload: { data }
  }
}

export const notesReportLoginToken = (data) => {
  return {
    type: NOTES_REPORT_LOGIN_TOKEN,
    payload: { data }
  }
}
